<template>
<div>
  <b-container fluid>
  <b-row v-if="!item.nimi">
        <InfoCard></InfoCard>
  </b-row>
  <b-row v-else-if="item.routestops && item.routestops.length >= 0" >
     <b-col v-if="item.departures && item.departures.length >= 0" :lg="cols" class="col-xl-12">                
            <div id="departureDiv">
            
            <TableActionHeader v-on:newItem="onNewItem" :searchInput="false"></TableActionHeader> 
            <b-table hover 
                selectable 
                select-mode="single" 
                :items="form.departures" 
                :responsive="false"
                :fields="fields"
                :small="true"
                @row-selected="onRowSelected"
                ref="departureList"
                primary-key="tunnus">
                <template v-slot:cell(reitti)="data">
                    <p class="mb-0">            
                    <b-form-group v-if='data.value != ""'>               
                        <b-icon icon="dash-square-fill" variant="danger" @click="remove(data.index , $event )" 
                        font-scale="1.5" v-b-tooltip.hover :title="$t('departure.delete.departure')" 
                        class="clickable"></b-icon>
                    </b-form-group>
                </p>
                </template>
            </b-table> 

            </div> 
            
      </b-col>
     </b-row>
   </b-container>
   
   <DeleteModal :modalid="'routeDepartureModal'" :itemid="this.selected ? this.departureTime(this.selected) : ''" @ok="onDeleteOK" />
    
</div>
  
</template>

<script>
import timetable from '@/store/timetable/timetable'
import i18n from '@/i18n'
import card  from '@/store/ui/card'

export default {
    data() {
        return {
            showForm: false,
            showPassingTimes: false,
            cols: 8,
            form: {
                departures: [],
                passingTimes: [],
            },
            fields: [
                { key:"lahtoaika" , label: this.$t('departure.departure_time'), sortable: true,
                  formatter: (value, key, item) => {
                     return this.departureTime(item);
                  }
                },                
                { key:"kausi" , label: this.$t('departure.season'), sortable: true },
                { key:"paivatyyppi" , label: this.$t('departure.daytype'), sortable: true },
                { key: "reitti", label: "" }
            ],
            sortBy:"lahtoaika",            
            selected: [],
            formType: "new",
            itemTemplate: { 
                "kausi": null,
                "paivatyyppi": null,
                "lahtoaika": null,
                "reitti": null
            }
        }   
    },
    props: {
        item: {
            required: true,
        },
        action: { default: "new" },
        departureUpdateTime : { default: null }
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        if( !this.$store.state.card ) {
            this.$store.registerModule('card' , card )
        }
        this.getDepartures(this.item);        
    },
    watch: {
        item: function(item) {            
            this.getDepartures(item);
        },
        departureUpdateTime() {
            console.log("departureUpdateTime changed")
            this.refreshDepartures(this.item.tunnus);
        }
    }, 
    computed: {
        formTitle(){
            return i18n.t('item.' + this.formType);
        },        
        route() {
            return this.form.tunnus;
        }
    },    
    methods: {
        getDepartures(item) {
            if( item && item.tunnus ) {
                this.form = item;
                this.$store.dispatch('timetable/getRouteDepartures' , this.form.tunnus )
                    .then( response => {
                        this.form.departures = response.data.departures;
                        if( this.form.departures.length === 0 ) {
                            this.showForm = true;
                        }
                    }
                );
            }
        }, 
        departureTime: function(item) {
            if( item.lahtoaika ) {
                const timeArray = item.lahtoaika.split("T")[1].split(":");                     
                const departureTime = parseInt(timeArray[0], 10) * 60 + parseInt(timeArray[1], 10);
                const hours = Math.floor(departureTime / 60);
                const minutes = departureTime - hours * 60;
                let timeStr = hours < 10 ? "0" + hours : hours;
                timeStr+= ":" + (minutes < 10 ? "0" + minutes : minutes); 
                return timeStr; 
            } else {
                return "";
            }
        },
        refreshDepartures (routeId) {
            if( routeId ) {
                this.$store.dispatch('timetable/getRouteDepartures' , routeId ).then( response => {
                    this.form.departures = response.data.departures;

                        if( this.form.departures.length === 0 ) {
                            this.showForm = true;
                        }
                    })
            }
        }, 
        refreshPassingTimes (routeId) {
            if( routeId ) {
                this.showEditor(false, "");
            }
        }, 
        showEditor: function(show, type) {
            this.showForm = show;
            this.showPassingTimes = !show;
            this.formType = type;
            this.cols = this.showForm ? 8 : 6;
        },
        onClose(){
            this.showEditor(false, "");
        },
        onNewItem() {
            const data = {}
            data.itemTemplate = { ...this.form.departures[0] }
            data.itemTemplate.lahtoaika = "00:00"
            data.route = this.route
            data.formType = "new"
            // this.$emit("showExtraCard" , { "card":"DepartureEdit", "data": data } )
            this.$store.commit('card/showCard' , { place:3 , name:"DepartureEdit" , data:data })
        },
        onRowSelected(index) {
            const data = {}
            data.departure=index[0]
            data.route = this.route
            data.actionType = this.formType
            //this.$emit("showExtraCard" , { "card":"PassingTimes", "data": data } )
            this.showForm = false;
            this.$store.commit('card/showCard' , { place:3 , name:"PassingTimes" , data:data })
            
        },
        cancelRemove(item){
            this.selected = item;
        },
        remove(index , event ){
            if( event ) {
                event.stopPropagation()
                event.preventDefault()
            }
            this.selected = this.form.departures[index];      
            this.$bvModal.show('routeDepartureModal')
        },
        onDeleteOK(){
            this.$travellerRemove();
            this.$store.dispatch('timetable/deleteDeparture' , this.selected, this.item.tunnus ).then( () => {
                this.$travellerRemoved();
                this.$store.dispatch('timetable/getRouteDepartures' , this.item.tunnus )
                    .then( response => {
                        this.form.departures = response.data.departures;
                        this.selected = {};

                }).finally(() => {
                     this.$emit("hideExtraCard") 
                })
            });
        }        
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#departureDiv {
  height: 40em;
  overflow: auto;
}
</style>

